import { render, staticRenderFns } from "./stationVent.vue?vue&type=template&id=2079fc3a&scoped=true"
import script from "./stationVent.vue?vue&type=script&lang=js"
export * from "./stationVent.vue?vue&type=script&lang=js"
import style0 from "./stationVent.vue?vue&type=style&index=0&id=2079fc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079fc3a",
  null
  
)

export default component.exports